import React, {useMemo} from 'react'
import {ILeague} from '@api/rank/league/league'
import Text from '@component/Text/Text'
import {useTranslation} from '@lib/intl/useTranslations'
import {TIME_DAY, TIME_HOUR} from '@constant/time'

interface IProps extends ILeague {
    className?: string
}

const LeagueLeftTimeTag: React.FC<IProps> = ({id, start_at, end_at, className}) => {
    const t = useTranslation()

    const displayTimeLeft = useMemo(() => {
        const now = Math.trunc(new Date().getTime() / 1000)

        if (now < start_at) {
            // starting soon (day, hour, soon)
            const leftTimeUntilStart = start_at - now
            if (leftTimeUntilStart < TIME_HOUR) {
                return t('league.leaderboard.leftTime.starting.soon')
            } else if (leftTimeUntilStart < TIME_DAY) {
                const hour = Math.trunc(leftTimeUntilStart / TIME_HOUR)
                return t('league.leaderboard.leftTime.starting.hours', {count: hour})
            } else {
                const day = Math.trunc(leftTimeUntilStart / TIME_DAY)
                return t('league.leaderboard.leftTime.starting.days', {count: day})
            }
        } else if (start_at < now && now < end_at) {
            // few days left (day, hour, soon)
            const leftTimeUntilEnd = end_at - now
            if (leftTimeUntilEnd < TIME_HOUR) {
                return t('league.leaderboard.leftTime.progress.soon')
            } else if (leftTimeUntilEnd < TIME_DAY) {
                const hour = Math.trunc(leftTimeUntilEnd / TIME_HOUR)
                return t('league.leaderboard.leftTime.progress.hoursLeft', {count: hour})
            } else {
                const day = Math.trunc(leftTimeUntilEnd / TIME_DAY)
                return t('league.leaderboard.leftTime.progress.daysLeft', {count: day})
            }
        } else {
            // ended
            return t('league.leaderboard.leftTime.ended.ended')
        }
    }, [start_at, end_at, t])

    return (
        <div
            className={`bg-white bg-opacity-10 rounded-[20px] px-[15px] py-[5px] md:py-[4px] md:px-[10px] whitespace-nowrap ${className}`}>
            <Text className={`text-ti3 text-white md:text-ti4`} enablePreWhiteSpace={false}>
                {displayTimeLeft}
            </Text>
        </div>
    )
}

export default LeagueLeftTimeTag
